
export default (context, inject) => {
  inject('sanierung', () => {
    const { query } = context.route
    const { store } = context

    if (query?.sanierung) {
      const status = query.sanierung
      const oldStatus = store.getters['customer/sanierungsStatus']
      if (oldStatus !== status) {
        localStorage.setItem('sanierung', status)
        store.dispatch('customer/changeSanierungsStatus', status)
        try {
          // eslint-disable-next-line no-undef
          clarity('set', 'sanierung', status)
        } catch (error) {
        }
      }
    }

    if (!query?.sanierung) {
      const status = localStorage.getItem('sanierung')
      if (status) {
        store.dispatch('customer/changeSanierungsStatus', status)
      }
    }
  })
}
